'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _analyticsNext = require('@atlaskit/analytics-next');

var _createContextData = require('../utils/create-context-data');

var _createContextData2 = _interopRequireDefault(_createContextData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnalyticsContextWrapper = function (_Component) {
    (0, _inherits3.default)(AnalyticsContextWrapper, _Component);

    function AnalyticsContextWrapper() {
        (0, _classCallCheck3.default)(this, AnalyticsContextWrapper);
        return (0, _possibleConstructorReturn3.default)(this, (AnalyticsContextWrapper.__proto__ || (0, _getPrototypeOf2.default)(AnalyticsContextWrapper)).apply(this, arguments));
    }

    (0, _createClass3.default)(AnalyticsContextWrapper, [{
        key: 'render',
        value: function render() {
            var data = (0, _createContextData2.default)(this.props);
            return _react2.default.createElement(
                _analyticsNext.AnalyticsContext,
                { data: data },
                this.props.children
            );
        }
    }]);
    return AnalyticsContextWrapper;
}(_react.Component);

exports.default = AnalyticsContextWrapper;